import axios from "axios";
import {API_URL, ERROR_SOME_THING_WRONG, ERROR_TO_MANY_REQUESTS, HEADER_PARAMETERS} from "../../../config";
import requestOptions from "@/mixins/prepare-requests/requestOptions";
import {mainStore} from "@/store/mainStore";
import {storeToRefs} from "pinia/dist/pinia";
import shared from "@/mixins/shared";
import {notificationStore} from "@/store/notificationStore";
import {useRouter} from "vue-router/dist/vue-router";

export default function userRequests() {
    const router = useRouter();
    const main = mainStore();
    const {changePlans, changePerson, changeTransactions} = main;
    const {transactions} = storeToRefs(main);
    const {prepareForLogout} = shared();
    const notifications = notificationStore();
    const {openSnackBarReject, changeShowConfirmEmailModal} = notifications;

    function getUser(isAuth) {
        axios.get(`${API_URL()}/api/auth/user`, {
            headers: requestOptions([HEADER_PARAMETERS.content, HEADER_PARAMETERS.accept, HEADER_PARAMETERS.authorization])
        })
            .then(response => {
                changePerson(response.data.data);
                checkConfirmEmail(response.data.data);
                if (isAuth) router.push('/');
            })
            .catch(error => handleError(error))
    }

    function getPlans() {
        axios.get(`${API_URL()}/api/plans`, {
            headers: requestOptions([HEADER_PARAMETERS.content, HEADER_PARAMETERS.accept, HEADER_PARAMETERS.authorization])
        })
            .then(response => changePlans(response.data.data))
            .catch(error => handleError(error))
    }

    function getPaymentLink(id) {
        axios.post(`${API_URL()}/api/payment`, {plan_id: id}, {
            headers: requestOptions([HEADER_PARAMETERS.content, HEADER_PARAMETERS.accept, HEADER_PARAMETERS.authorization])
        })
            .then(response => location.href = response.data.link)
            .catch(error => handleError(error))
    }

    function getTransactions(selectPage) {
        const page = transactions.value?.pagination?.current_page ? selectPage : 1;
        axios.get(`${API_URL()}/api/payment/transactions?page=${page}`, {
            headers: requestOptions([HEADER_PARAMETERS.content, HEADER_PARAMETERS.accept, HEADER_PARAMETERS.authorization])
        })
            .then(response => changeTransactions(response.data))
            .catch(error => handleError(error))
    }

    function deleteAccount() {
        axios.post(`${API_URL()}/api/auth/delete`, {}, {
            headers: requestOptions([HEADER_PARAMETERS.content, HEADER_PARAMETERS.accept, HEADER_PARAMETERS.authorization])
        })
            .then(() => prepareForLogout())
            .catch(error => handleError(error))
    }

    function checkConfirmEmail(personData) {
        if (!personData?.id) return;

        if (!personData?.email_verified_at) {
            changeShowConfirmEmailModal(true);
        }
    }

    function handleError(error) {
        let errorMessage = null;
        changeShowConfirmEmailModal(false);
        switch (error.response?.status) {
            case 401:
                prepareForLogout();
                break;
            case 500:
            case 404:
                openSnackBarReject(ERROR_SOME_THING_WRONG);
                break;
            case 429:
                openSnackBarReject(ERROR_TO_MANY_REQUESTS);
                break;
            case 503:
            case 422:
            case 409:
                errorMessage = error.response?.data?.message || error.response?.data?.error
                openSnackBarReject(errorMessage);
        }
    }

    return {
        getUser,
        getPlans,
        getPaymentLink,
        getTransactions,
        deleteAccount
    }
}
